const javascriptExpressionType = {
    FUNCTION : 'function',

    OPERATOR : 'operator',

    CONSTANT : 'constant'

};

angular.module('gw-um-j2js')
    .constant('javascriptExpressionType', javascriptExpressionType);